import styled from 'styled-components';
import { Grid, Utils, Modal as ModalModule } from 'billon-ui';

const { Button: ButtonModule } = Utils;
const { BackButton: BillonBackButton } = ButtonModule;
const { ModalFooter: BillonModalFooter } = ModalModule;
const { Col } = Grid;

export const ModalFooter = styled(BillonModalFooter)`
  padding-left: 0;
  padding-right: 0;
`;

export const ZeroCol = styled(Col)`
  padding-left: 11.2px;
`;

export const BackButton = styled(BillonBackButton)`
  padding: 0;
`;
